import { Directive, ElementRef, Input, OnInit, inject, Self, Optional, OnDestroy } from '@angular/core';
import { NgModel } from '@angular/forms';

import { Subscription } from 'rxjs';

import styles from './vb-ui-text-area.module.less';

@Directive({
	selector: '[vbUiTextArea]',
	host: {
		'[class]': 'hostClass'
	},
	standalone: false
})
export class VbTextAreaDirective implements OnInit, OnDestroy {
	@Input() public height: number;
	@Input() public autoResize: boolean = false;
	public hostClass: string = `${styles.textArea} 'theme-accent-border-focus'`;

	private readonly elementRef = inject(ElementRef);
	private modelSubscription: Subscription;

	constructor(
		@Optional() @Self() private readonly model: NgModel
	) { }

	public ngOnInit(): void {
		if (this.height) {
			this.elementRef.nativeElement.style.setProperty('--vb-ui-text-area-height', this.height + 'px');
		}
		if (this.autoResize) {
			this.modelSubscription = this.model?.valueChanges?.subscribe(() => this.resize());
		}
	}

	public ngOnDestroy(): void {
		this.modelSubscription?.unsubscribe();
	}

	private resize(): void {
		this.elementRef.nativeElement.style.height = this.elementRef.nativeElement.scrollHeight + 'px';
	}
}
